import { Controller } from '@hotwired/stimulus'

// Тот же ключ, что и у compare_bar_controller.js / compare_picker_controller.js
// — убрали ракетку из сравнения прямо на странице результата, значит и на
// её собственной странице товара она больше не должна числиться "уже
// добавленной".
const STORAGE_KEY = 'padelmesh:compare-slugs'

/**
 * @file Крестик удаления ракетки из сравнения на странице результата (см.
 * compares/show.slim) — сама ссылка уже ведёт на URL без этого товара
 * (обычная навигация, тут её не перехватываем), контроллер только держит
 * localStorage-список в согласии с ней.
 */
export default class CompareRemoveController extends Controller {
  static values = { slug: String }

  remove() {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)
      const list = raw ? JSON.parse(raw) : []
      if (!Array.isArray(list)) return

      const next = list.filter((slug) => slug !== this.slugValue)
      if (next.length !== list.length) {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
      }
    } catch {
      // Приватный режим браузера и подобное — персистентного списка просто
      // нет, синхронизировать с ним нечего.
    }
  }
}
